import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Payment methods',
  fields: {
    hidden_payment_methods: {
      label: 'Hidden payment methods',
    },
    has_online_payments: {
      label: 'Has online payments',
    },
    has_paypal_upcharge: {
      label: 'Upcharge 3.5% extra for paypal transactions',
    },
    has_cash_payments: {
      label: 'Has cash payments',
    },
    has_occ_cash_payments: {
      label: 'Call Center cash payments enabled',
    },
    has_in_store_card_payments: {
      label: 'Has in-store card payments',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Label cash payments as "Invoice"',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Card',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'Sepa debit',
    [PaymentMethods.CASH]: 'Cash',
    [PaymentMethods.BACS_DEBIT]: 'Bacs debit',
    [PaymentMethods.PAY_BY_BANK]: 'Pay by bank',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Pickup',
    [ORDER_METHODS.delivery]: 'Delivery',
    [ORDER_METHODS.on_site]: 'Table ordering',
  },
  modals: {
    confirmation: {
      title: 'Are you sure?',
      description:
        'Once confirmed, online payments will be <strong>{{onlineState}}</strong>, cash payments will be <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'off',
    on: 'on',
  },
  buttons: {
    save: 'Save',
    configure_online_payments: 'Configure online payments',
  },
  toasts: {
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
  },
};
